/** お気に入り一覧ページの URL パス */
export const ME_FAVORITES_PATH = '/me/favorites'
